// extracted by mini-css-extract-plugin
export default {"select":"Select_select__UQfyF","title":"Select_title__Yga1h"};